export enum InboxTabs {
  inbox = "inbox",
  archive = "archive",
  sent = "skickat",
}
